import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Card, Collapse, Row } from "react-bootstrap";
import PopoverHelp from "../../../Docuclipper/PopoverHelp";
type Props = {
  renderHelp?: () => JSX.Element;
  heading: string;
  expanded: boolean;
  hasError: boolean;
  setExpanded: (expanded: boolean) => any;
};
export const FieldSection: React.SFC<Props> = ({
  children,
  renderHelp,
  heading,
  hasError,
  expanded,
  setExpanded,
}) => {
  //   const [expanded, setExpanded] = React.useState(false);
  const toggle = () => setExpanded(!expanded);
  return (
    <Card>
      <Card.Header style={{ cursor: "pointer" }} onClick={toggle}>
        <Row className="justify-content-around align-items-center">
          {hasError && (
            <FontAwesomeIcon
              className="mr-1"
              icon="exclamation-triangle"
              color="red"
            />
          )}
          <div
            style={{ width: "70%", color: hasError ? "red" : "" }}
            className="h5 mb-0"
          >
            {heading}
          </div>
          {renderHelp && (
            <PopoverHelp header="" id="fieldPreviewHelp" placement="bottom">
              {renderHelp()}
            </PopoverHelp>
          )}
          <FontAwesomeIcon icon={expanded ? "chevron-up" : "chevron-down"} />
        </Row>
      </Card.Header>

      <Collapse in={expanded}>
        <Card.Body>{children}</Card.Body>
      </Collapse>
    </Card>
  );
};
export default FieldSection;
